/**
 * useEscClose — Ferme un composant quand l'utilisateur appuie sur Echap.
 *
 * §11/§18 DA — hook a11y réutilisable pour modals, drawers, popovers.
 * Câblé dans ModalShell.
 *
 * @param {boolean} active — activer/désactiver le listener
 * @param {() => void} onClose — callback appelé à l'appui Echap
 *
 * @example
 *   useEscClose(isOpen, () => setOpen(false));
 */
import { useEffect } from 'react';

export function useEscClose(active, onClose) {
  useEffect(() => {
    if (!active) return;

    function handleKeyDown(e) {
      if (e.key === 'Escape') onClose();
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [active, onClose]);
}
